var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stage-heading"},[_vm._t("pin",function(){return [_c('div',{staticClass:"stage-heading__pin"})]}),_c('h3',[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }